<template>
  <base-page
    :title="$t('products.create_product')"
    :large-layout="true"
  >
    <template #main>
      <v-row
        v-if="isLoading"
        align="center"
        justify="center"
        class="mt-10"
      >
        <v-progress-circular
          :size="125"
          :width="10"
          color="primary"
          indeterminate
        />
      </v-row>
      <product-create-update-form
        v-if="!isLoading"
        :template="template"
      />
    </template>
  </base-page>
</template>
<script>
import BasePage from '@/views/BasePage.vue'
import ProductCreateUpdateForm from "../../components/Product/ProductCreateUpdateForm"
import { mapActions } from 'vuex'

export default {
  components: {
    BasePage,
    ProductCreateUpdateForm
  },
  data() {
    return {
      isLoading: true,
      template: {}
    }
  },
  methods: {
    ...mapActions(['ensureTemplate']),
  },
  async mounted() {
    if (this.$route.query.template) {
      this.isLoading = true
      const payload = { id: this.$route.query.template }
      // Includes template & variants
      const template = await this.ensureTemplate(payload)
      this.template = { ...template }
      this.isLoading = false
    }
  }
}
</script>
